export function Loading(){
    return (
        <span className="lds-dual-ring"></span>
    )
}